import React from 'react';
import { auth } from '../firebase-config';
import { GoogleAuthProvider, signInWithPopup, OAuthProvider } from 'firebase/auth';
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import withRouter from "components/Common/withRouter";
import { loginSocial } from "../store/auth/login/actions";

const SignInWithGoogle = props => {
  const dispatch = useDispatch();

  const signInWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const userData = {
          email: result.user?.email,
          idToken: result.user.accessToken,
          provider: 'google'
        };
        dispatch(loginSocial(userData, props.router.navigate));
      }).catch((error) => {
        console.error("Google sign in error:", error);
      });
  };

  const signInWithApple = () => {
    const provider = new OAuthProvider('apple.com');
    provider.addScope('email');
    provider.addScope('name');
    
    signInWithPopup(auth, provider)
      .then((result) => {
        const credential = OAuthProvider.credentialFromResult(result);
        const userData = {
          email: result.user?.email,
          idToken: result.user.accessToken,
          provider: 'apple'
        };
        dispatch(loginSocial(userData, props.router.navigate));
      }).catch((error) => {
        console.error("Apple sign in error:", error);
      });
  };

  return (
    <div className="d-flex justify-content-center gap-2">
      <Link
        to="#"
        className="social-list-item bg-danger text-white border-danger"
        onClick={signInWithGoogle}
        title="Войти через Google"
      >
        <i className="mdi mdi-google" />
      </Link>
      <Link
        to="#"
        className="social-list-item bg-dark text-white border-dark"
        onClick={signInWithApple}
        title="Войти через Apple"
      >
        <i className="mdi mdi-apple" />
      </Link>
    </div>
  );
}

export default withRouter(SignInWithGoogle);